import jQuery from 'jquery';
import { tdAnimationScroll } from './animation-scroll';
import { tdDetect } from '../core/detect';
import { tdEvents } from '../core/events';

/**
 * abstract:
 * - check all items in page, sort them using one of a sorted methods and add them in the items array
 * - at every scroll the items are verified if they are in view port or above
 * - every item in view port is added into the _items_in_view_port array and they are ready for animation
 * - items above view port are animated all at once
 * - items in view port are animated at crescendo intervals [interval / remaining items]
 * - there's a max and a min interval
 * - td_block ajax request response use a sort method and add founded items into view port array or into items array
 */

export const tdAnimationStack: Record<string, any> = {

    /*
        Important:
        1. The first animation step is produced by the the body selector @see animation-stack.less
        2. The second animation step can be applied by the animation_css_class1
        3. The final (the main) animation step is applied by the animation_css_class2
     */




    // - flag css class used by the non 'type0' animation effect
    // - flag used just to look for not yet computed item
    // - it's set by ready_init (on ready)
    // - all dom components that need to be animated will be marked with this css class in ready_init
    // - it can be used for a precomputed style, but carefully, because it's applied at ready_init (on ready)
    _animation_css_class1: '',



    // - flag css class used by the non 'type0' animation effect
    // - flag css class used to animate custom
    // - this css class applies the final animation
    _animation_css_class2: '',



    // - the default animation effect 'type0' is applied if the global window.td_animation_stack_effect is the empty string
    // - it's used for consistency of animation effects presented into the animation-stack.less [all types have a name (...type...)]
    _animation_default_effect: 'type0',



    // - tdAnimationStack runs just only when this flag is true
    // - it's done true by the init function
    activated: false,



    // flag checked by the major animation operations
    _ready_for_initialization: true,

    // interval used by ready_init to check tdAnimationStack state
    _ready_init_timeout: undefined,


    // max time[ms] interval waiting for first tdAnimationStack.init call
    max_waiting_for_init: 3000,



    // the specific selectors are used to look for new elements inside of the specific sections
    _specific_selectors: '',

    // the general selectors are used to look for elements over extend areas in DOM
    _general_selectors: '',

    // - tdAnimationStack loads the items just when the animation occurs
    live_load_items: false,





    /**
     * - wait for tdAnimationStack.init() for max_waiting_for_init time
     * - if time is elapsed, the animation is canceled
     * - the ready_init is canceled by a fast tdAnimationStack.init call
     */
    ready_init: function() {

        // - special case for IE8 and IE9 (and if Visual Composer image carousel exists)
        // Important! The Visual Compose images carousel has hidden elements (images) that does not allow for computing the real position of the other DOM elements in the viewport
        // - the animation is forced removed and the altered css body is cleaned
        if ( tdDetect.isIe8 || tdDetect.isIe9 || ( jQuery( '.vc_images_carousel' ).length > 0 ) ) {
            tdAnimationStack._ready_for_initialization = false;

            if ( undefined !== window.td_animation_stack_effect ) {
                if ( '' === window.td_animation_stack_effect ) {
                    window.td_animation_stack_effect = tdAnimationStack._animation_default_effect;
                }
                jQuery( 'body' ).removeClass( 'td-animation-stack-' + window.td_animation_stack_effect );
            }
            return;
        }


        if ( undefined === window.tds_animation_stack || undefined === window.td_animation_stack_effect ) {

            // lock any further operation using the _ready_for_initialization flag
            tdAnimationStack._ready_for_initialization = false;

        } else {

            // the tdAnimationStack._specific_selectors is set by the global variable window.td_animation_stack_specific_selectors
            if ( undefined !== window.td_animation_stack_specific_selectors ) {
                tdAnimationStack._specific_selectors = window.td_animation_stack_specific_selectors;
            }


            // if the global variable window.td_animation_stack_effect has the empty string value, the 'full fade' (type0) effect is prepared to be applied
            if ( '' === window.td_animation_stack_effect ) {
                window.td_animation_stack_effect = tdAnimationStack._animation_default_effect;
            }

            tdAnimationStack._animation_css_class1 = 'td-animation-stack-' + window.td_animation_stack_effect + '-1';
            tdAnimationStack._animation_css_class2 = 'td-animation-stack-' + window.td_animation_stack_effect + '-2';


            // - the tdAnimationStack._general_selectors is set by the global variable window.td_animation_stack_general_selectors
            if ( undefined !== window.td_animation_stack_general_selectors ) {
                tdAnimationStack._general_selectors = window.td_animation_stack_general_selectors;
            }

            // the tdAnimationStack._animation_css_class1 css class is applied for all elements need to be animated later
            jQuery( tdAnimationStack._general_selectors).addClass( tdAnimationStack._animation_css_class1 );


            // - timeout used by the ready_init function, to cut down tdAnimationStack.init calling at loading page, when the call comes too late
            // - if tdAnimationStack.init comes earlier, it does a clearTimeout call over the tdAnimationStack._ready_init_timeout variable
            tdAnimationStack._ready_init_timeout = setTimeout( function() {

                // if tdAnimationStack is activated, do nothing
                if ( true === tdAnimationStack.activated ) {
                    return;
                }

                // lock any further operation using the _ready_for_initialization flag
                tdAnimationStack._ready_for_initialization = false;

                // remove the loading animation css class effect from the body
                // this class is applied from the theme settings
                if ( undefined !== window.td_animation_stack_effect ) {
                    jQuery( 'body' ).removeClass( 'td-animation-stack-' + window.td_animation_stack_effect );
                }

            }, tdAnimationStack.max_waiting_for_init );
        }
    },


    // flag marks items where they are
    _ITEM_TO_VIEW_PORT: {

        ITEM_ABOVE_VIEW_PORT: 0,

        ITEM_IN_VIEW_PORT: 1,

        ITEM_UNDER_VIEW_PORT: 2
    },


    // predefined sorting methods
    SORTED_METHOD: {

        sort_left_to_right: function sort_left_to_right( item1, item2 ) {
            if ( item1.offset_top > item2.offset_top ) {
                return 1;
            } else if ( item1.offset_top < item2.offset_top ) {
                return -1;
            } else if ( item1._order > item2._order ) {
                return 1;
            } else if ( item1._order < item2._order ) {
                return -1;
            }
            return 0;
        },


        sort_right_to_left: function sort_right_to_left( item1, item2 ) {
            if ( item1.offset_top > item2.offset_top ) {
                return 1;
            } else if ( item1.offset_top < item2.offset_top ) {
                return -1;
            } else if ( item1._order > item2._order ) {
                return -1;
            } else if ( item1._order < item2._order ) {
                return 1;
            }
            return -1;
        }
    },


    // keeps the DOM reading order, used in the sorting methods
    _order: 0,


    // interval divided to animate items
    // ex. interval 100 and 2 items => one item at 100 / 2 and one item at 100 / 1, but not lower than min_interval and not higher than max_interval
    interval: 70,

    // min interval of a set timer
    min_interval: 17,

    // max interval of a set timer
    max_interval: 40,



    // keep current setInterval
    _current_interval: undefined,

    // items in view port are moved here
    _items_in_view_port: [],

    // items above the view port are moved here
    _items_above_view_port: [],

    // all items that will be processed
    items: [],








    /**
     * - tdAnimationStack.item
     */
    item: function() {
        // offset from the top of the item, to the top
        // it's set at the initialization item
        this.offset_top = undefined;


        // offset from the bottom of the item, to the top
        // it's set at the initialization item
        this.offset_bottom_to_top = undefined;


        // jquery object reference
        // it's set before the initialization of the item
        this.jqueryObj = undefined;


        // the reading order from DOM
        // it's set at the initialization item
        this._order = undefined;

        // the img source
        this.itemSrc = undefined;

        // the img type
        this.itemType = undefined;

        // the retina img uuid
        this.itemImgRetinaSrc = undefined;
    },




    /**
     * - initialize a tdAnimationStack.item and add it in tdAnimationStack.items
     * @param item tdAnimationStack.item
     */
    //add_item: function add_item(item) {
    //
    //    if (item.constructor != tdAnimationStack.item) {
    //        return;
    //    }
    //
    //    tdAnimationStack.items.push(item);
    //},



    /**
     * - initialize the offset top of the tdAnimationStack.item parameter
     * @param item tdAnimationStack.item
     * @private
     */
    _initialize_item: function( item ) {
        item._order = tdAnimationStack._order++;

        item.offset_top = item.jqueryObj.offset().top;
        //item.offset_relative = Math.sqrt(Math.pow(item.jqueryObj.offset().top, 2) + Math.pow(item.jqueryObj.offset().left, 2));

        item.offset_bottom_to_top = item.offset_top + item.jqueryObj.height();

        //item.jqueryObj.parent().prepend('<div class="debug_item" style="position: absolute; width: 100%; height: 20px; border: 1px solid red; background-color: white">' + item.offset_top + '</div>');
    },


    /**
     * - dynamically search for new elements to create new tdAnimationStack.item
     * - the items are added in the tdAnimationStack._items_in_view_port, that means they are ready to be animated,
     * or in the tdAnimationStack.items to be computed later (checked if they are in the view port and animated)
     * @param selector {string} - jQuery selector
     * @param sort_type {tdAnimationStack.SORTED_METHOD} - a preferred tdAnimationStack.SORTED_METHOD
     * @param in_view_port {boolean} - add an item in the tdAnimationStack._items_in_view_port or in the tdAnimationStack.items
     * @param live_load_items {boolean} - the items are loaded just when the animation occurs
     */
    check_for_new_items: function( selector, sort_type, in_view_port, live_load_items ) {

        // tdAnimationStack must be activated and not stopped for initialization by the ready_init checker
        if ( ( false === tdAnimationStack.activated ) || ( false === tdAnimationStack._ready_for_initialization ) ) {
            return;
        }

        if ( undefined === selector ) {
            selector = '';
        }

        // the local stack of searched items
        var local_stack = [];

        jQuery( tdAnimationStack._general_selectors).not( '.' + tdAnimationStack._animation_css_class2 ).addClass( tdAnimationStack._animation_css_class1 );

        // for every founded element there's an instantiated tdAnimationStack.item, then initialized and added to the local stack
        var founded_elements = jQuery( selector + ', .post' ).find( tdAnimationStack._specific_selectors ).filter( function() {
                return jQuery( this ).hasClass( tdAnimationStack._animation_css_class1 );
            });

        // found elements
        founded_elements.each( function( index, element ) {

            var item_animation_stack = new tdAnimationStack.item();

            item_animation_stack.jqueryObj = jQuery( element );
            item_animation_stack.itemSrc = jQuery( element ).data('img-url');
            item_animation_stack.itemType = jQuery( element ).data('type');

            if ( jQuery( element ).data('img-retina-url') !== undefined ) {
                item_animation_stack.itemImgRetinaSrc = jQuery( element ).data('img-retina-url');
            }

            tdAnimationStack._initialize_item( item_animation_stack );

            local_stack.push( item_animation_stack );
        });

        if ( true === live_load_items ) {

            tdAnimationStack.log( '%c live load items ', 'background: brown; color: white;' );

            /**
             * the images are loaded just when the animation occurs
             */
            tdAnimationStack._precompute_items( local_stack, sort_type, in_view_port );
            tdAnimationStack.compute_items(live_load_items);
        } else {

            tdAnimationStack.log( '%c preload items ', 'background: brown; color: white;' );

            // new scope having its own timer used for checking not yet loaded images
            ( function(){

                var images_loaded = true;

                for ( var i = 0; i < local_stack.length; i++ ) {

                    // for every image element the 'complete' property is checked
                    // "If the image is finished loading, the complete property returns true"
                    // when tdAnimationStack.init is called on load, as normally, it calls tdAnimationStack.check_for_new_items and all these element has 'complete' property true
                    // when tdAnimationStack.check_for_new_items is called by block's ajax response, the next timer is used to wait for all elements being loaded
                    if ( false === founded_elements[ i ].complete ) {
                        images_loaded = false;
                        break;
                    }
                }

                // if there's at least one element not loaded, a timer is started to wait for
                if ( false === images_loaded ) {

                    var date = new Date();
                    var start_time = date.getTime();


                    tdAnimationStack.log( 'TIMER - started' );


                    // the timer is started
                    var interval_check_loading_image = setInterval( function() {

                        // if there's too much time waiting for image loading, they are made visible
                        var date = new Date();

                        var i = 0;

                        if ( ( date.getTime() - start_time ) > tdAnimationStack.max_waiting_for_init ) {

                            clearInterval( interval_check_loading_image );

                            for ( i = 0; i < local_stack.length; i++ ) {

                                //if (window.td_animation_stack_effect === 'type0') {
                                //    local_stack[i].jqueryObj.css('opacity', 1);
                                //} else {
                                local_stack[ i ].jqueryObj.removeClass( tdAnimationStack._animation_css_class1 );
                                local_stack[ i ].jqueryObj.addClass( tdAnimationStack._animation_css_class2 );
                                //}

                            }
                            return;
                        }


                        // at every interval step, the element's 'complete' property is checked again
                        images_loaded = true;

                        for ( i = 0; i < local_stack.length; i++ ) {

                            if ( false === founded_elements[ i ].complete ) {
                                images_loaded = false;
                                break;
                            }
                        }

                        if ( true === images_loaded ) {

                            clearInterval( interval_check_loading_image );

                            tdAnimationStack.log( 'TIMER - stopped' );

                            tdAnimationStack._precompute_items( local_stack, sort_type, in_view_port );
                            tdAnimationStack.compute_items(false);
                        }

                    }, 100);

                } else {
                    tdAnimationStack._precompute_items( local_stack, sort_type, in_view_port );
                    tdAnimationStack.compute_items(false);
                }

            })();
        }

        tdAnimationStack.log( 'checked for new items finished' );
    },


    /**
     * - _precompute_items sorts and adds items in the tdAnimationStack.items array or even in the tdAnimationStack._items_in_view_port array
     * - this function is necessary because at scroll just the tdAnimationStack.compute_items function is called
     *
     * @param stack_items {[]} founded items
     * @param sort_type {function} sorting method
     * @param in_view_port {boolean} add in view port to be already computed, or in the general items array
     * @private
     */
    _precompute_items: function( stack_items, sort_type, in_view_port ) {

        stack_items.sort( sort_type );

        if ( true === in_view_port ) {

            while ( stack_items.length > 0 ) {
                tdAnimationStack.log( 'add item 1 : ' + stack_items.length );
                tdAnimationStack._items_in_view_port.push( stack_items.shift() );
            }

        } else {

            while (stack_items.length > 0) {
                tdAnimationStack.log( 'add item 2 : ' + stack_items.length );
                tdAnimationStack.items.push( stack_items.shift() );
            }
        }
    },



    /**
     * - IT'S CALLED ON PAGE LOAD [actually in tdLastInit.js]
     * - the general init function
     * - the items are added to the tdAnimationStack.items using check_for_new_items method, and then computed
     * - the arrays are cleared to be prepared for a reinitialization
     */
    init: function() {
        if ( undefined === window.tds_animation_stack ) {
            tdAnimationStack.log( '%c theme lazy loading animation is off! ', 'background: #eb4026;' );
            return;
        }

        tdAnimationStack.log( '%c theme lazy loading animation is on! ', 'background: #03c04a; color: #fff;' );

        // tdAnimationStack must not be already stopped for initialization by a pre_init checker
        if ( false === tdAnimationStack._ready_for_initialization ) {
            return;
        }

        // clear the _ready_init_timeout, to stop it doing more checking
        clearTimeout( tdAnimationStack._ready_init_timeout );

        // the tdAnimationStack is activated
        tdAnimationStack.activated = true;

        tdAnimationStack.check_for_new_items( '.td-animation-stack', tdAnimationStack.SORTED_METHOD.sort_left_to_right, false, true );
    },


    /**
     * - the arrays are cleared to be prepared for a reinitialization
     * - the init call is done
     */
    reinit: function() {

        // tdAnimationStack must not be already stopped for initialization by a pre_init checker
        if ( false === tdAnimationStack._ready_for_initialization ) {
            return;
        }

        tdAnimationStack.items = [];
        tdAnimationStack._items_in_view_port = [];
        tdAnimationStack._items_above_view_port = [];

        tdAnimationStack.init();
    },


    /**
     * - compute all items
     * - live_load_items - if 'true' the items will also be loaded on show,
     *                   - if 'false' the items are preloded so they just need to be shown
     */
    compute_items: function(live_load_items) {

        // tdAnimationStack must be activated and not stopped for initialization by the ready_init checker
        if ( ( false === tdAnimationStack.activated ) || ( false === tdAnimationStack._ready_for_initialization ) ) {
            return;
        }

        // the tdAnimationStack.items are processed
        tdAnimationStack._separate_items();

        // the items above the port view are animated
        while ( tdAnimationStack._items_above_view_port.length > 0 ) {
            tdAnimationStack.log( 'animation - above the view port' );

            var item_above_view_port = tdAnimationStack._items_above_view_port.shift();

            if ( live_load_items === true ) {
                // load current item
                tdAnimationStack._load_item(item_above_view_port, false);
                tdAnimationStack.log( '%c item above view port - loaded ', 'background: #fef24e; color: #000;' );

            } else {
                item_above_view_port.jqueryObj.removeClass( tdAnimationStack._animation_css_class1 );
                item_above_view_port.jqueryObj.addClass( tdAnimationStack._animation_css_class2 );
            }

        }


        // the items in the port view are prepared to be animated
        if ( tdAnimationStack._items_in_view_port.length > 0 ) {

            // clear any opened interval by a previous compute_items call
            clearInterval( tdAnimationStack._current_interval );

            var current_animation_item = tdAnimationStack._get_item_from_view_port();

            if ( live_load_items === true ) {
                // load current item
                tdAnimationStack._load_item(current_animation_item, false);
                tdAnimationStack.log( '%c item in view port - loaded ', 'background: #fef24e; color: #000;' );

            } else {
                current_animation_item.jqueryObj.removeClass( tdAnimationStack._animation_css_class1 );
                current_animation_item.jqueryObj.addClass( tdAnimationStack._animation_css_class2 );
            }

            if ( tdAnimationStack._items_in_view_port.length > 0 ) {

                tdAnimationStack.log( 'start animation timer' );

                tdAnimationStack._to_timer( tdAnimationStack._get_right_interval( tdAnimationStack.interval * ( 1 / tdAnimationStack._items_in_view_port.length ) ), live_load_items );
            }
        }
    },


    /**
     * - timer function initially called by a tdAnimationStack.compute_items function, and then it's auto called
     * - it calls a setInterval using the interval parameter
     * @param interval {int} - interval ms
     * @param live_load_items {bool} - whether to also load the img items or just show them
     */
    _to_timer: function( interval, live_load_items ) {

        tdAnimationStack._current_interval = setInterval( function () {

            if ( tdAnimationStack._items_in_view_port.length > 0 ) {

                var current_animation_item = tdAnimationStack._get_item_from_view_port();

                tdAnimationStack.log( 'animation at interval: ' + interval );

                if ( live_load_items === true ) {
                    // load current item
                    tdAnimationStack._load_item(current_animation_item, false);
                    tdAnimationStack.log( '%c item above view port - loaded > _to_timer ', 'background: #3895d3; color: #fff;' );
                } else {
                    current_animation_item.jqueryObj.removeClass( tdAnimationStack._animation_css_class1 );
                    current_animation_item.jqueryObj.addClass( tdAnimationStack._animation_css_class2 );
                }

                clearInterval( tdAnimationStack._current_interval );

                if ( tdAnimationStack._items_in_view_port.length > 0 ) {
                    tdAnimationStack._to_timer( tdAnimationStack._get_right_interval( tdAnimationStack.interval * ( 1 / tdAnimationStack._items_in_view_port.length ) ), live_load_items );
                }
            }
        }, interval );
    },


    /**
     * - get an item from the tdAnimationStack._items_in_view_port array
     * @returns {tdAnimationStack.item}
     * @private
     */
    _get_item_from_view_port: function() {

        return tdAnimationStack._items_in_view_port.shift();
    },



    /**
     * - get the interval considering tdAnimationStack.min_interval and tdAnimationStack.max_interval
     * @param interval {int} - the checked interval value
     * @returns {int} - the result interval value
     * @private
     */
    _get_right_interval: function( interval ) {

        if ( interval < tdAnimationStack.min_interval ) {
            return tdAnimationStack.min_interval;

        } else if ( interval > tdAnimationStack.max_interval ) {
            return tdAnimationStack.max_interval;
        }
        return interval;
    },


    /**
     * - check where the item is to the view port
     * @param item {tdAnimationStack.item}
     * @returns {number} _ITEM_TO_VIEW_PORT value
     * @private
     */
    _item_to_view_port: function( item ) {

        tdAnimationStack.log( 'position item relative to the view port >> yOffset ' + tdEvents.window_pageYOffset + ' | xOffset ' + tdEvents.window_innerHeight + ' : ' + item.offset_top );

        if ( tdEvents.window_pageYOffset + tdEvents.window_innerHeight < item.offset_top ) {
            return tdAnimationStack._ITEM_TO_VIEW_PORT.ITEM_UNDER_VIEW_PORT;

        } else if ( ( tdEvents.window_pageYOffset + tdEvents.window_innerHeight >= item.offset_top ) && ( tdEvents.window_pageYOffset <= item.offset_bottom_to_top ) ) {
            return tdAnimationStack._ITEM_TO_VIEW_PORT.ITEM_IN_VIEW_PORT;

        }
        return tdAnimationStack._ITEM_TO_VIEW_PORT.ITEM_ABOVE_VIEW_PORT;
    },


    /**
     * - check the sorted tdAnimationStack.items and move them into the _items_above_view_port array or into the _items_in_view_port
     * - the remaining items are kept by the tdAnimationStack.items for next processing
     * @private
     */
    _separate_items: function() {
        if ( 0 === tdAnimationStack.items.length ) {
            return;
        }

        tdAnimationStack.log( '%c _separate_items - total items: ' + tdAnimationStack.items.length + ' ', 'background: #999da0; color: #fff;' );

        while ( tdAnimationStack.items.length > 0 ) {
            var item_to_view_port = tdAnimationStack._item_to_view_port( tdAnimationStack.items[ 0 ] );

            switch ( item_to_view_port ) {
                case tdAnimationStack._ITEM_TO_VIEW_PORT.ITEM_ABOVE_VIEW_PORT :
                    tdAnimationStack._items_above_view_port.push( tdAnimationStack.items.shift() );
                    break;

                case tdAnimationStack._ITEM_TO_VIEW_PORT.ITEM_IN_VIEW_PORT :
                    tdAnimationStack._items_in_view_port.push( tdAnimationStack.items.shift() );
                    break;

                case tdAnimationStack._ITEM_TO_VIEW_PORT.ITEM_UNDER_VIEW_PORT :
                    tdAnimationStack.log( 'after separation items >> above: ' + tdAnimationStack._items_above_view_port.length + ' in: ' + tdAnimationStack._items_in_view_port.length + ' under: ' + tdAnimationStack.items.length );
                    return;
            }
        }
    },

    /**
     * - loads an item(img)
     * @param item
     * @param item_test
     * @private
     */
    _load_item: function( item, item_test ) {

        if ( undefined === item.itemSrc ) {
            tdAnimationStack.log( '%c item with no data url ', 'background: #fc6600; color: #fff;' );

            // for items for which we have not att data source to load just show the img
            item.jqueryObj.removeClass( tdAnimationStack._animation_css_class1 );
            item.jqueryObj.addClass( tdAnimationStack._animation_css_class2 );

        } else {

            var itemType = item.itemType;

            if ( itemType !== undefined ) {

                switch ( itemType ) {
                    case 'image_tag':

                        tdAnimationStack.log( '%c image tag ', 'background: #3ded97; color: #fff;' );

                        //if ( item_test ) {
                        //  item.itemSrc = item.itemSrc + 'caca';
                        //}

                        item.jqueryObj.data('complete', false);

                        // first we check if a retina image was delivered and if the device screen supports it
                        if ( item.itemImgRetinaSrc !== undefined && tdAnimationStack.isRetina === true ) {
                            item.jqueryObj.attr( 'src', item.itemImgRetinaSrc ).load( function(){
                                item.jqueryObj.data('complete', true);
                            });
                        } else {
                            item.jqueryObj.attr( 'src', item.itemSrc ).load( function(){
                                item.jqueryObj.data('complete', true);
                            });
                        }

                        var date = new Date();
                        var start_time = date.getTime();

                        // the timer is started
                        var interval_check_loading_image = setInterval( function() {

                            // if there's too much time waiting for image loading, they are made visible
                            var date = new Date();

                            // at every interval step, the element's 'complete' property is checked again
                            if ( item.jqueryObj.data('complete') === true ){

                                // the img item loading is complete, clear the interval
                                clearInterval( interval_check_loading_image );

                                // ..and show the img item
                                item.jqueryObj.removeClass( tdAnimationStack._animation_css_class1 );
                                item.jqueryObj.addClass( tdAnimationStack._animation_css_class2 );

                                return;
                            }

                            // check if the maximum waiting time has been reached
                            if ( ( date.getTime() - start_time ) > tdAnimationStack.max_waiting_for_init ) {

                                // the img item loading maximum waiting time has been reached, clear the interval
                                clearInterval( interval_check_loading_image );

                                // ..and show the img item
                                item.jqueryObj.removeClass( tdAnimationStack._animation_css_class1 );
                                item.jqueryObj.addClass( tdAnimationStack._animation_css_class2 );
                            }

                        }, 100);

                        break;

                    case 'css_image':

                        item.jqueryObj.data('complete', false);

                        tdAnimationStack.log( '%c image tag ', 'background: #3ded97; color: #fff;' );

                        // check for retina support and image delivery and if the device screen supports it then load the retina img
                        if ( item.itemImgRetinaSrc !== undefined && tdAnimationStack.isRetina === true ) {

                            /**
                             * to find out when the bg img is loaded, for spans with css image,
                             * we create a new img tag and set the src to the css bg img then, after it loads, we set it as bg img for the span
                             */
                            // @ts-ignore
                            jQuery('<img/>').attr( 'src', item.itemImgRetinaSrc ).load( function() {
                                jQuery(this).remove(); //remove the img to prevent memory leaks
                                item.jqueryObj.data('complete', true);
                            });
                        } else {
                            // @ts-ignore
                            jQuery('<img/>').attr( 'src', item.itemSrc ).load( function() {
                                jQuery(this).remove(); //remove the img to prevent memory leaks
                                item.jqueryObj.data('complete', true);
                            });
                        }

                        var date2 = new Date();
                        var start_time2 = date2.getTime();

                        // the timer is started
                        var interval_check_loading_css_image = setInterval( function() {

                            // if there's too much time waiting for image loading, they are made visible
                            var date = new Date();

                            // at every interval step, the element's 'complete' property is checked again
                            if ( item.jqueryObj.data('complete') === true ){

                                if ( item.itemImgRetinaSrc !== undefined && tdAnimationStack._isHighDensity() === true ) {
                                    item.jqueryObj.attr( 'style', 'background-image: url(' + item.itemImgRetinaSrc + ')' );
                                } else {
                                    item.jqueryObj.attr( 'style', 'background-image: url(' + item.itemSrc + ')' );
                                }

                                // the img item loading is complete, clear the interval
                                clearInterval( interval_check_loading_css_image );

                                // ..and show the img item
                                item.jqueryObj.removeClass( tdAnimationStack._animation_css_class1 );
                                item.jqueryObj.addClass( tdAnimationStack._animation_css_class2 );

                                return;
                            }

                            // check if the maximum waiting time has been reached
                            if ( ( date.getTime() - start_time2 ) > tdAnimationStack.max_waiting_for_init ) {

                                // the img item loading maximum waiting time has been reached, clear the interval
                                clearInterval( interval_check_loading_css_image );

                                // set the bg image, if we have retina we set the retina img
                                if ( item.itemImgRetinaSrc !== undefined && tdAnimationStack._isHighDensity === true ) {
                                    item.jqueryObj.attr( 'style', 'background-image: url(' + item.itemImgRetinaSrc + ')' );
                                } else {
                                    item.jqueryObj.attr( 'style', 'background-image: url(' + item.itemSrc + ')' );
                                }

                                // ..and show the img item
                                item.jqueryObj.removeClass( tdAnimationStack._animation_css_class1 );
                                item.jqueryObj.addClass( tdAnimationStack._animation_css_class2 );
                            }

                        }, 100);

                        break;
                }
            }
        }
    },


    /**
     * - scroll event usually called by tdCustomEvents
     */
    td_events_scroll: function() {
        tdAnimationStack.compute_items(true);
    },



    /**
     * - resize event usually called by tdCustomEvents
     */
    td_events_resize: function() {
        // clear an existing interval
        clearInterval( tdAnimationStack._current_interval );

        // reinitialize tdAnimationStack searching in page for not already animated items [which were already repositioned by resize]
        tdAnimationStack.reinit();
    },



    log: function( msg, style ) {

        if ( style !== undefined ) {
            //console.log(msg, style);
        } else {
            //console.log(msg);
        }

    },


    _isHighDensity: function () {
        return (
            (
                window.matchMedia && (
                    window.matchMedia(
                        'only screen and (min-resolution: 124dpi), ' +
                        'only screen and (min-resolution: 1.3dppx), ' +
                        'only screen and (min-resolution: 48.8dpcm)'
                    ).matches ||
                    window.matchMedia(
                        'only screen and (-webkit-min-device-pixel-ratio: 1.3), ' +
                        'only screen and (-o-min-device-pixel-ratio: 2.6/2), ' +
                        'only screen and (min--moz-device-pixel-ratio: 1.3), ' +
                        'only screen and (min-device-pixel-ratio: 1.3)'
                    ).matches
                )
            ) || (
                window.devicePixelRatio && window.devicePixelRatio > 1.3
            )
        );
    },

    _isRetina: function () {
        return (
            (
                window.matchMedia && (
                    window.matchMedia(
                        'only screen and (min-resolution: 192dpi), ' +
                        'only screen and (min-resolution: 2dppx), ' +
                        'only screen and (min-resolution: 75.6dpcm)'
                    ).matches ||
                    window.matchMedia(
                        'only screen and (-webkit-min-device-pixel-ratio: 2), ' +
                        'only screen and (-o-min-device-pixel-ratio: 2/1), ' +
                        'only screen and (min--moz-device-pixel-ratio: 2), ' +
                        'only screen and (min-device-pixel-ratio: 2)'
                    ).matches
                )
            ) || (
                window.devicePixelRatio && window.devicePixelRatio >= 2
            )
        ) && /(iPad|iPhone|iPod)/g.test( navigator.userAgent );
    }

};



/**
 * parallax effect
 */

// array keeping the tdAnimationScroll.item items used for backstretch
export var td_backstretch_items = [];


jQuery(window).ready(function() {

    jQuery('.td-backstretch').each(function (index, element) {

        if (!jQuery(element).hasClass('not-parallax')) {

            var item = new tdAnimationScroll.item();
            item.jqueryObj = jQuery(element);
            item.wrapper_jquery_obj = item.jqueryObj.parent();

            // - ideal translation is when the top of wrapper_jquery_obj is at the top of the view port, the jqueryObj image
            // is also already translated at the top of the view port
            // - the start_value should be item.wrapper_jquery_obj.offset().top + how much the jqueryObj was translated

            tdAnimationScroll.add_item(item);

            // we keep the tdAnimationScroll.item to change operation settings when the viewport is changing
            td_backstretch_items.push(item);

            td_compute_backstretch_item(item);
        }
    });


    jQuery('.td-parallax-header').each(function (index, element) {

        var item = new tdAnimationScroll.item();
        item.jqueryObj = jQuery(element);

        item.add_item_property('move_y', 50, 100, 0, 100, '');
        item.add_item_property('opacity', 50, 100, 1, 0, '');

        item.animation_callback = function () {

            var move_y_property = parseFloat(item.computed_item_properties['move_y']).toFixed();
            var opacity_property = parseFloat(item.computed_item_properties['opacity']);

            item.jqueryObj.css({
                '-webkit-transform': 'translate3d(0px,' + move_y_property + 'px, 0px)',
                'transform': 'translate3d(0px,' + move_y_property + 'px, 0px)'
            });

            item.jqueryObj.css('transform', 'translate3d(0px,' + move_y_property + 'px, 0px)');

            item.jqueryObj.css('opacity', opacity_property);

            item.redraw = false;
        }

        tdAnimationScroll.add_item(item);
    });



    tdAnimationScroll.compute_all_items();



    // We need to come after videos wrappers have been inserted in page (@todo after iframe load??)
    setTimeout(function() {

        jQuery('.tdc-video-parallax-wrapper').each(function (index, element) {
            td_compute_parallax_background(element);
        });

        tdAnimationScroll.compute_all_items();

    }, 300);





    // load animation stack
    tdAnimationStack.ready_init();
});




export function td_compute_parallax_background( htmlElement ) {

    var $el = jQuery(htmlElement);

    var move_y_val = Math.round( $el.height() * 0.2 ),
        start_move_y_val = -1 * move_y_val,
        end_move_y_val = move_y_val;

    var item = new tdAnimationScroll.item();
    item.jqueryObj = $el;

    item.add_item_property('move_y', 0, 100, start_move_y_val, end_move_y_val, '');

    item.animation_callback = function () {

        var move_y_property = parseFloat(item.computed_item_properties['move_y']).toFixed();

        item.jqueryObj.css({
            '-webkit-transform': 'translate3d(0px,' + move_y_property + 'px, 0px) scale(1.2)',
            'transform': 'translate3d(0px,' + move_y_property + 'px, 0px) scale(1.2)'
        });

        item.redraw = false;

        // Flag used to reinitialize item at resize (we need to reinitialize it because its container dimensions can change - and also the properties applied to the item )
        item.td_video_parallax = true;
    }

    tdAnimationScroll.add_item(item);
}





/**
 * Function used to register the 'move_y' property for every td_animations_scroll.item item of the td_backstretch_items array.
 * It scales the object image and translate it. At first it is translated so its bottom is at the bottom of the viewport,
 * but considering the backstretch css classes applied
 *
 * @param item tdAnimationScroll.item
 */
export function td_compute_backstretch_item(item) {

        // Important! The following variables must be computed after add_item calling function, because they need item.full_height, item.offset_top, etc

        // percent when the object is in initial position
        // Important! It doesn't matter if the document is scrolled
        var initial_percent = (tdEvents.window_innerHeight - item.offset_top) * 100 / (tdEvents.window_innerHeight + item.full_height);

        // percent when the object has its top at the top of the window
        var intermediary_top_percent =  (tdEvents.window_innerHeight) * 100 / (tdEvents.window_innerHeight + item.full_height);


        // IMPORTANT! We suppose the item.offset_top is positive


        // the value used to compute the scale_factor
        // Important! It can be any value
        var scale_seed = item.offset_top / 4;

        // if item.offset_top is zero, we set the scale_seed at a custom value
        if (scale_seed == 0) {
            scale_seed = 100;
        }

        // the start_value is half of the scale_seed, so the object [image] is translated as its bottom is at the bottom of its view
        var start_value = - scale_seed / 2;


        // DO NOT DELETE THE NEXT CODE LINES. The right value would be the next, but the divide operation does not have 100% accuracy, so we increase the interval
        // and so we are sure the object is not translated more than needed when is at the top of the window
        //
        // When the top of the view is at the top of the window, the object [image] must be already translated at the top of the window.
        //
        //var end_value = ((100 - initial_percent) * scale_seed) / (intermediary_top_percent - initial_percent);;
        //
        //or actually
        //
        //var end_value = ((100 - initial_percent) * (item.offset_top / 2)) / (intermediary_top_percent - initial_percent);;

        var end_value = ((100 - initial_percent) * (scale_seed / 1.2)) / (intermediary_top_percent - initial_percent);

        // fix for firefox. It rounds up and loose 1 pixel
        start_value += 0.5;


        // if there already exists a 'move_y' property, it is removed
        item.remove_item_property('move_y');

        item.add_item_property('move_y', initial_percent, 100, start_value, end_value, '');


        // @ts-ignore
        var scale_factor = parseFloat(1 + Math.abs(scale_seed) / item.full_height).toFixed(2);


        // if there's already registered an 'animation_callback' function, it is removed
        delete item.animation_callback;

        item.animation_callback = function () {

            var property_value = parseFloat(item.computed_item_properties['move_y']).toFixed();

            item.jqueryObj.css({
                'left': '50%',
                '-webkit-transform': 'translate3d(-50%,' + property_value + 'px, 0px) scale(' + scale_factor + ',' + scale_factor + ')',
                'transform': 'translate3d(-50%,' + property_value + 'px, 0px) scale(' + scale_factor + ',' + scale_factor + ')'
            });

            item.redraw = false;
        };
}
